import React, { Component } from 'react'
import './App.css';
import Navigation from './components/navigation';
import Header from './components/header';
import Features from './components/features';
import YouTubeFeature from './components/youtube';
import About from './components/about';
import Services from './components/services';
import Team from './components/Team';
import Contact from './components/contact';
import JsonData from './data/data.json';

export class App extends Component {
  state = {
    landingPageData: {},
  }
  getlandingPageData() {
    this.setState({ landingPageData: JsonData })
  }

  componentDidMount() {
    this.getlandingPageData();
  }

  render() {
    return (
      <div>
        <Navigation />
        <Header data={this.state.landingPageData.Header} />
        <Features data={this.state.landingPageData.Features} />
        <YouTubeFeature />
        <Services data={this.state.landingPageData.Services} />
        <About data={this.state.landingPageData.About} />
        <Team data={this.state.landingPageData.Team} />
        <Contact data={this.state.landingPageData.Contact} />
      </div>
    )
  }
}

export default App;
